// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errMsg {
  margin-top: -1.3em;
  font-size: 75%;
}

.dottedLine {
  position: relative;
  padding-bottom: 8px;
  cursor: default;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.42) 0%, rgba(0, 0, 0, 0.42) 33%, transparent 0%);
  background-repeat: repeat-x;
  background-position-y: 24px;
  background-size: 4px 1px;
}

::ng-deep {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep [mat-icon-button],
::ng-deep [mat-button] {
  outline: none !important;
}
::ng-deep text-field {
  line-height: 1.25rem;
}
::ng-deep mat-form-field {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field.dotted .mat-form-field-wrapper .mat-form-field-underline {
  display: none;
}
::ng-deep .mat-icon,
::ng-deep .material-icons:not([sx]) {
  width: 1.25rem !important;
  height: 1.25rem !important;
  font-size: 1.25rem !important;
  line-height: 1.25rem !important;
}
::ng-deep .mat-form-field-wrapper {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep .mat-form-field-wrapper .mat-form-field-prefix {
  top: 0.25rem;
  padding-right: 0.52rem;
}
::ng-deep .mat-form-field-wrapper .mat-form-field-suffix {
  top: 0.25rem;
  padding-left: 0.52rem;
}

.toggle-green {
  color: #0f9d58;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/new-order/new-order1/new-order1.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,cAAA;AACD;;AAEA;EACC,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4GAAA;EAMA,2BAAA;EACA,2BAAA;EACA,wBAAA;AAJD;;AAOA;EA2BC,gIAAA;EACA,gIAAA;AA9BD;AAGC;;EAEC,wBAAA;AADF;AAIC;EACC,oBAAA;AAFF;AAKC;EAEC,gIAAA;AAJF;AAKE;EACC,aAAA;AAHH;AASC;;EAEC,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,+BAAA;AAPF;AAWC;EAEC,gIAAA;EAMA,gIAAA;AAfF;AAUE;EACC,YAAA;EACA,sBAAA;AARH;AAYE;EACC,YAAA;EACA,qBAAA;AAVH;;AAeA;EACC,cAAA;AAZD","sourcesContent":[".errMsg {\n\tmargin-top: -1.3em;\n\tfont-size: 75%;\n}\n\n.dottedLine {\n\tposition: relative;\n\tpadding-bottom: 8px;\n\tcursor: default;\n\tbackground-image: linear-gradient(\n\t\tto right,\n\t\trgba(0, 0, 0, 0.42) 0%,\n\t\trgba(0, 0, 0, 0.42) 33%,\n\t\ttransparent 0%\n\t);\n\tbackground-repeat: repeat-x;\n\tbackground-position-y: 24px;\n\tbackground-size: 4px 1px;\n}\n\n::ng-deep {\n\t[mat-icon-button],\n\t[mat-button] {\n\t\toutline: none !important;\n\t}\n\n\ttext-field {\n\t\tline-height: 1.25rem;\n\t}\n\n\tmat-form-field {\n\t\t// Read only input dotted line\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t&.dotted .mat-form-field-wrapper .mat-form-field-underline {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t// Undoing a little bit of the global styling that is overriding\n\t// the material design native styles.\n\t.mat-icon,\n\t.material-icons:not([sx]) {\n\t\twidth: 1.25rem !important;\n\t\theight: 1.25rem !important;\n\t\tfont-size: 1.25rem !important;\n\t\tline-height: 1.25rem !important;\n\t}\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t.mat-form-field-wrapper {\n\t\t// Icon leading an input.\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-prefix {\n\t\t\ttop: 0.25rem;\n\t\t\tpadding-right: 0.52rem;\n\t\t}\n\t\t// Icon trailing an input.\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-suffix {\n\t\t\ttop: 0.25rem;\n\t\t\tpadding-left: 0.52rem;\n\t\t}\n\t}\n}\n\n.toggle-green {\n\tcolor: #0f9d58;\n  }\t\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
